<template>
  <section
    class="section-bg py-space-lg py-lg-space-xxl position-relative rds-lazy"
    :data-background-image="bgImage"
  >
    <div class="container">
      <div class="row mx-0">
        <div class="col-12">
          <h2 class="h2-medium pb-space-sm" v-html="title"></h2>
          <div class="bg-secondary title-underline mb-space-md"></div>
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-12">
          <div class="explore-grid w-100">
            <div v-for="(card, index) in items" :key="index" class="explore-grid-item">
              <card-link-atlas
                class="w-100 h-100"
                :image-source="card.image"
                :title="card.title"
                :is-clickable="true"
                @card-click="handleLinkEvent($event, card)"
                @card-enter="handleEnterKeyEvent(card)"
              ></card-link-atlas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { analyticsComposable } from "@rds-vue-ui/analytics-gs-composable";
import { CardLinkAtlas } from "@rds-vue-ui/card-link-atlas";
import type { LinkItem } from "~/types/types";

export interface ExploreItem {
  title: string;
  image: string;
  link: LinkItem;
}
interface Props {
  title?: string;
  items: ExploreItem[];
  bgImage?: string;
}
const props = withDefaults(defineProps<Props>(), {
  title: "Lorem Ipsum",
  bgImage: "https://cms.asuonline.asu.edu/sites/default/files/topo-pattern.jpg"
});

const handleLinkEvent = (event: Event, card: ExploreItem) => {
  event.preventDefault();

  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    props.title.toLowerCase(),
    card.title.toLowerCase(),
    "section-explore-your-future"
  );
  navigateTo(card.link.uri, { external: true });
};
const handleEnterKeyEvent = (card: ExploreItem) => {
  navigateTo(card.link.uri, { external: true });
};
</script>

<style lang="scss" scoped>
.explore-grid {
  display: inline-grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  place-items: stretch;
  row-gap: 1rem;
}
.section-bg {
  background-size: auto;
  background-position: top;
}
.title-underline {
  width: 64px;
  height: 10px;
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .explore-grid {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    row-gap: 24px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .explore-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
